import React from "react";
import { Button } from "../components/Button";
import styles from "./Footer.module.css";
import { Loader } from "./Loader";

export type FooterProps = {
  totalResults: number;
  totalVisibleResults: number;
  onLoadMoreClick?: () => void;
  loading?: boolean;
};

export const FooterComponent = ({
  totalResults,
  totalVisibleResults,
  onLoadMoreClick,
  loading,
}: FooterProps) => {
  return (
    <div className={styles.container}>
      {totalResults > 1 && (
        <div className={styles.page}>
          <strong>
            {totalVisibleResults} van {totalResults}
          </strong>{" "}
          opleidingen
        </div>
      )}

      {totalVisibleResults < totalResults && (
        <div className={styles.more}>
          {loading ? (
            <Loader loading={loading} />
          ) : (
            <Button
              variation="secondary"
              label="Toon meer opleidingen"
              onClick={onLoadMoreClick}
            />
          )}
        </div>
      )}
    </div>
  );
};

export const Footer = React.memo(FooterComponent);
